import create from 'zustand'
import { persist } from 'zustand/middleware'

import { KINERJA_PS_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY } from 'app/KinerjaPSPegawaiPage/configs/perilaku-kerja'
import { KINERJA_PS_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY } from 'app/KinerjaPSPegawaiPage/configs/praktikKinerja'
import {
  KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY,
  KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_V2_DRAFT_STORAGE_KEY,
} from 'app/KinerjaPSPegawaiPage/configs/pengembanganKompetensi'

import type { PSPerilakuKerjaAspek } from 'types/kinerja-ps-pegawai'

type TPraktikKinerjaDraftStoreState = {
  draftPraktikKinerja?: string | undefined
  draftSatuanPendidikan?: string[]
  setDraft: (id: string | undefined, ids: string[]) => void
  hasDraft: () => boolean
}
export const usePraktikKinerjaDraftStore =
  create<TPraktikKinerjaDraftStoreState>(
    persist(
      (set, get) => ({
        draftPraktikKinerja: undefined,
        draftSatuanPendidikan: [],
        setDraft: (praktikKinerjaId = undefined, satuanPendidikanIds = []) =>
          set(() => ({
            draftPraktikKinerja: praktikKinerjaId,
            draftSatuanPendidikan: satuanPendidikanIds,
          })),
        hasDraft: (): boolean =>
          Boolean(get()?.draftPraktikKinerja) ||
          (get()?.draftSatuanPendidikan ?? []).length > 0,
      }),
      {
        name: KINERJA_PS_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY,
      }
    )
  )

interface TPerilakuKerjaStoreState {
  selectedPerilakuKerja: PSPerilakuKerjaAspek[]

  hasDraft: () => boolean
  saveDraft: (perilakuKerja: Array<PSPerilakuKerjaAspek>) => void
}

export const usePerilakuKerjaStore = create<TPerilakuKerjaStoreState>(
  persist(
    (set, get) => ({
      selectedPerilakuKerja: [],
      saveDraft: (data) => {
        set((state) => {
          return {
            ...state,
            selectedPerilakuKerja: data,
          }
        })
      },
      hasDraft: (): boolean => {
        return get().selectedPerilakuKerja.length > 0
      },
    }),
    {
      name: KINERJA_PS_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY,
    }
  )
)

type TPengembanganKompetensiDraftStoreState = {
  draftIndicator?: any
  draftActivities?: any[]
  setDraft: (indicator: any, activities: any[]) => void
  hasDraft: () => boolean
}
export const usePengembanganKompetensiDraftStore =
  create<TPengembanganKompetensiDraftStoreState>(
    persist(
      (set, get) => ({
        draftIndicator: undefined,
        draftActivities: [],
        setDraft: (indicator = undefined, activities = []) =>
          set(() => ({
            draftIndicator: indicator,
            draftActivities: activities,
          })),
        hasDraft: (): boolean =>
          Boolean(get()?.draftIndicator) ||
          (get()?.draftActivities ?? []).length > 0,
      }),
      {
        name: KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY,
      }
    )
  )

type TPengembanganKompetensiV2DraftStoreState = {
  draftPemantauan?: string | undefined
  draftPenilaian?: string | undefined
  draftPembinaan?: string | undefined
  setDraft: (
    pemantauan: string | undefined,
    penilaian: string | undefined,
    pembinaan: string | undefined
  ) => void
  hasDraft: () => boolean
}
export const usePengembanganKompetensiV2DraftStore =
  create<TPengembanganKompetensiV2DraftStoreState>(
    persist(
      (set, get) => ({
        draftPemantauan: undefined,
        draftPenilaian: undefined,
        draftPembinaan: undefined,
        setDraft: (pemantauan, penilaian, pembinaan) =>
          set(() => ({
            draftPemantauan: pemantauan,
            draftPenilaian: penilaian,
            draftPembinaan: pembinaan,
          })),
        hasDraft: (): boolean =>
          Boolean(get()?.draftPemantauan) ||
          Boolean(get()?.draftPenilaian) ||
          Boolean(get()?.draftPembinaan),
      }),
      {
        name: KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_V2_DRAFT_STORAGE_KEY,
      }
    )
  )

export const STORES_WITH_STORAGE_KEY = [
  [
    usePraktikKinerjaDraftStore,
    KINERJA_PS_PERENCANAAN_PRAKTIK_KINERJA_DRAFT_STORAGE_KEY,
  ],
  [
    usePerilakuKerjaStore,
    KINERJA_PS_PERENCANAAN_PERILAKU_KERJA_DRAFT_STORAGE_KEY,
  ],
  [
    usePengembanganKompetensiDraftStore,
    KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY,
  ],

  // V2
  [
    usePengembanganKompetensiV2DraftStore,
    KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_V2_DRAFT_STORAGE_KEY,
  ],
]
